<template>
  <div class="m-budget">
    <span class="m-budget__title">Budget</span>
    <span class="m-budget__value">
      <span class="u-font-backup m-budget__symbol">£</span>{{ getBudget | currency }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getBudget']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/Budget.vue